<template>
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.83617 13.3035L14.703 19.1702C14.8387 19.306 15.0199 19.3809 15.213 19.3809C15.4061 19.3809 15.5873 19.306 15.723 19.1702L16.155 18.7383C16.4362 18.4568 16.4362 17.9994 16.155 17.7183L11.2285 12.7918L16.1605 7.85981C16.2962 7.72401 16.3711 7.54298 16.3711 7.34995C16.3711 7.15669 16.2962 6.97566 16.1605 6.83976L15.7284 6.40792C15.5926 6.27212 15.4116 6.1973 15.2185 6.1973C15.0253 6.1973 14.8442 6.27212 14.7085 6.40792L8.83617 12.28C8.70016 12.4162 8.62545 12.5981 8.62588 12.7915C8.62545 12.9856 8.70016 13.1674 8.83617 13.3035Z" fill="white"/>
    </svg>
</template>

<script>
export default {
    name: 'ArrowLeftIcon'
}
</script>
